import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["requiredField", "mappingSelect", "status", "submit", "warningAcknowledgment"]
  static values = {
    rowLimitBlocked: Boolean,
    incompleteMessage: String,
    completeMessage: String,
    blockedMessage: String,
    samples: Object
  }

  connect() {
    this.updateState()
  }

  updateState() {
    this.mappingSelectTargets.forEach(select => {
      const row = select.closest("tr")
      const badge = row.querySelector("[data-mapping-status]")
      const sample = row.querySelector("[data-mapping-sample]")
      const selected = select.value.trim().length > 0
      const status = selected ? "matched" : select.required ? "attention" : "unused"
      badge.className = `column-mapping__badge column-mapping__badge--${status}`
      badge.textContent = selected ? "Matched" : select.required ? "Needs attention" : "Not in file"
      sample.textContent = selected ? (this.samplesValue[select.value] || "—") : "—"
    })

    const complete = this.requiredFieldTargets.every(field => field.value.trim().length > 0)
    const warningsReviewed = !this.hasWarningAcknowledgmentTarget || this.warningAcknowledgmentTarget.checked
    this.submitTarget.disabled = !complete || this.rowLimitBlockedValue || !warningsReviewed
    if (this.rowLimitBlockedValue) {
      this.statusTarget.textContent = this.blockedMessageValue
    } else if (!warningsReviewed) {
      this.statusTarget.textContent = "Review the flagged columns before continuing"
    } else {
      this.statusTarget.textContent = complete ? this.completeMessageValue : this.incompleteMessageValue
    }
  }
}
